import { Component } from '@angular/core';
import { PaymentDashboardTablesComponent } from '../payment-dashboard-tables.component';

@Component({
  selector: 'app-account-activity-table',
  templateUrl: './account-activity-table.component.html',
  styleUrls: ['./account-activity-table.component.scss'],
})
export class AccountActivityTableComponent extends PaymentDashboardTablesComponent {}
